import con from '@services/connection'
import { configuracoes } from '@constants/URL'

/**
 * To call: store.dispatch('addExample', '')
 */

const load = async ({ commit, state }, payload) => {
  if (state.loading || !payload || !state.desatualizado) {
    return state.dados
  }

  commit('SET_LOADING', true)

  const r = await con.get(configuracoes.blacklist.manage + payload)

  if (r.status === 200) {
    commit('SET_DESATUALIZADO', false)

    commit('UPDATE_BLACKLIST', r.value)
  }

  commit('SET_LOADING', false)

  return state.dados
}

const setDesatualizado = ({ commit }) => {
  commit('SET_DESATUALIZADO', true)
}

export { load, setDesatualizado }
